/* eslint-disable react/jsx-filename-extension */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable import/prefer-default-export */
import React from 'react'
import clsx from 'clsx'
import { CheckIcon } from './CheckIcon'
import { IntermediateIcon } from './IntermediateIcon'

import { hasSelectedChildren } from '../../utils/dropdownUtils'
import s from './DropdownRow.module.css'

/**
 * Individual row component for dropdown options
 */
export const DropdownRow = React.memo(({ data, index, style }) => {
  const { filteredOptions, selectedValues, toggleValue, toggleCollapse, collapsed } = data
  const option = filteredOptions[index]
  const isChecked = selectedValues.includes(option.value)
  const isParent = !!option.children
  const isIntermediateState = hasSelectedChildren(option, selectedValues)

  return (
    <div
      className={s.dropdownItem}
      style={{ ...style, paddingLeft: (option.level ?? 0) * 20 }}
      onClick={(e) => {
        e.stopPropagation()
        toggleValue(option.value)
      }}
    >
      <div className={s.dropdownCheck}>
        {isChecked && <CheckIcon />}
        {isIntermediateState && !isChecked && <IntermediateIcon />}
      </div>

      <div className={s.dropdownContent}>{option.content || option.label}</div>

      {isParent && (
        <div
          onClick={(e) => {
            e.stopPropagation()
            toggleCollapse(option.value)
          }}
          className={clsx(s.dropdownArrow, collapsed.has(option.value) && s.dropdownArrowReversed)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="13"
            height="7"
            viewBox="0 0 13 7"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M0.173162 6.00374L6.08195 0.171063C6.13683 0.116833 6.202 0.0738119 6.27373 0.0444592C6.34546 0.0151066 6.42235 -5.75036e-07 6.5 -5.68248e-07C6.57765 -5.61459e-07 6.65454 0.0151066 6.72627 0.0444593C6.798 0.0738119 6.86317 0.116833 6.91805 0.171063L12.8268 6.00375C12.9377 6.11319 13 6.26163 13 6.41641C13 6.57119 12.9377 6.71963 12.8268 6.82907C12.716 6.93851 12.5656 7 12.4088 7C12.252 7 12.1016 6.93851 11.9907 6.82907L6.5 1.40832L1.00926 6.82907C0.954358 6.88326 0.889184 6.92625 0.817455 6.95558C0.745727 6.9849 0.668847 7 0.591208 7C0.51357 7 0.436691 6.9849 0.364963 6.95558C0.293234 6.92625 0.22806 6.88326 0.173162 6.82907C0.118262 6.77488 0.0747147 6.71054 0.0450039 6.63974C0.0152932 6.56893 4.43193e-08 6.49304 5.10193e-08 6.41641C5.77192e-08 6.33977 0.0152932 6.26388 0.045004 6.19308C0.0747147 6.12227 0.118262 6.05794 0.173162 6.00374Z"
              fill="white"
            />
          </svg>
        </div>
      )}
    </div>
  )
})
